import React, { useState, useEffect } from 'react';
import MainLayout from '../layouts/MainLayout';
import { useLocation } from 'react-router-dom';

// Dynamically import all images from the media folder
const importAll = (r) => r.keys().map((key) => r(key).default || r(key));

// This requires a folder at src/assets/img/media containing your media images
const mediaImages = importAll(require.context('../assets/img/media', false, /\.(png|jpe?g|avif|webp|svg)$/i));

function Media() {
    const { pathname } = useLocation();
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0); // Always scroll to top when opening the page
    }, [pathname]);

    return (
        <MainLayout>
            <section className="gallery-section bg-light py-5 min-vh-100">
                <div className="container section-title text-center mb-5 mt-4" data-aos="fade-up">
                    <h1 className="display-4 fw-bolder mb-3 text-uppercase text-heritage-maroon">
                        Media Coverage
                    </h1>
                    <div className="mx-auto mb-4" style={{ width: '80px', height: '4px', background: 'linear-gradient(to right, #8c1c13, #0d1b2a)', borderRadius: '2px' }}></div>
                    <p className="text-muted fs-5">Press releases, news, and media coverage of Mahawar Sabha, Rewari.</p>
                </div>

                <div className="container" data-aos="fade-up" data-aos-delay="100">
                    <div className="bg-white p-4 rounded-4 shadow-sm border-gold">
                        <div className="row g-4">
                            {mediaImages.length > 0 ? (
                                mediaImages.map((img, imgIndex) => (
                                    <div className="col-sm-6 col-md-4 col-lg-3" key={imgIndex}>
                                        <div className="img-wrapper rounded-3 shadow-sm overflow-hidden hover-lift h-100 bg-light p-1 border">
                                            <img 
                                                src={img} 
                                                alt={`Media Coverage ${imgIndex + 1}`} 
                                                className="img-fluid w-100 rounded-2" 
                                                style={{ height: '220px', objectFit: 'contain', cursor: 'pointer' }} 
                                                loading="lazy"
                                                onClick={() => setSelectedImage(img)}
                                            />
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12 text-center py-5">
                                    <p className="text-muted fs-5">No media images available yet.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Lightbox Modal */}
                {selectedImage && (
                    <div 
                        className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                        style={{ backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 9999 }}
                        onClick={() => setSelectedImage(null)}
                    >
                        <button 
                            className="btn-close btn-close-white position-absolute top-0 end-0 m-4 p-2" 
                            onClick={() => setSelectedImage(null)}
                        ></button>
                        <img 
                            src={selectedImage} 
                            alt="Full Screen View" 
                            style={{ maxHeight: '90vh', maxWidth: '90vw', objectFit: 'contain' }} 
                        />
                    </div>
                )}
            </section>
        </MainLayout>
    );
}

export default Media;